import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";

import { Dashboardconstant } from "./dashboardConstant";

const initialState = {
  dashboardrevenueList: [{}],
  dashboardrevenue: {
    isLoading: false,
  },
  cutomersdataList: [{}],
  customerdata: {
    isLoading: false,
  },
  timeconsumeddataList: [{}],
  timeconsumeddata: {
    isLoading: false,
  },
  powerconsumeddataList: [{}],
  powerconsumeddata: {
    isLoading: false,
  },
  populartimesdataList: [{}],
  populartimesdata: {
    isLoading: false,
  },
};

export const DashboardReducer = persistReducer(
  {
    storage,
    key: "DashboardReducer",
    whitelist: [
      " dashboardrevenueList",
      "customerdata",
      "timeconsumeddataList",
      "powerconsumeddataList",
      "populartimesdataList",
    ],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case Dashboardconstant.DASHBOARD_REVENUE_REQUEST: {
        return {
          ...state,
          dashboardrevenueList: [],
          dashboardrevenue: {
            isLoading: true,
          },
        };
      }
      case Dashboardconstant.DASHBOARD_REVENUE_RESPONSE: {
      
        return {
          ...state,
          dashboardrevenueList: payload,
          dashboardrevenue: {
            isLoading: false,
          },
        };
      }

      case Dashboardconstant.CUSTOMERS_REQUEST: {
        return {
          ...state,
          cutomersdataList: [],
          customerdata: {
            isLoading: true,
          },
        };
      }
      case Dashboardconstant.CUSTOMERS_RESPONSE: {
        return {
          ...state,
          cutomersdataList: payload,
          customerdata: {
            isLoading: false,
          },
        };
      }

      case Dashboardconstant.TIME_CONSUMED_REQUEST: {
        return {
          ...state,
          timeconsumeddataList: [],
          timeconsumeddata: {
            isLoading: true,
          },
        };
      }
      case Dashboardconstant.TIME_CONSUMED_RESPONSE: {
        return {
          ...state,
          timeconsumeddataList: payload,
          timeconsumeddata: {
            isLoading: false,
          },
        };
      }

      case Dashboardconstant.POWER_CONSUMED_REQUEST: {
        return {
          ...state,
          powerconsumeddataList: [],
          powerconsumeddata: {
            isLoading: true,
          },
        };
      }
      case Dashboardconstant.POWER_CONSUMED_RESPONSE: {
        return {
          ...state,
          powerconsumeddataList: payload,
          powerconsumeddata: {
            isLoading: false,
          },
        };
      }

      case Dashboardconstant.POPULAR_TIMES_REQUEST: {
        return {
          ...state,
          populartimesdataList: [],
          populartimesdata: {
            isLoading: true,
          },
        };
      }
      case Dashboardconstant.POPULAR_TIMES_RESPONSE: {
        return {
          ...state,
          populartimesdataList: payload,
          populartimesdata: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
